import React from 'react'
import SortIcon from '../../icons/SortIcon'

interface IconComponentProps {
    direction?: 'ASC' | 'DESC'
    className: string
}

const IconComponent: React.FC<IconComponentProps> = ({
    direction,
    className
}) => <SortIcon direction={direction} className={className} />

export default IconComponent
